import InvoicePrint from "../layouts/Print/InvoicePrint";
import InvoiceReminder from "../layouts/Print/InvoiceReminder";
import InvoiceDownload from "../layouts/Print/InvoiceDownload";
import CornJob from "../layouts/Print/CornJob";
import SendSmsEmailWhatsapp from "../layouts/Print/SendSmsEmailWhatsapp";

const printRoutes = [
  { path: "/invoice-print/:invoiceId", element: <InvoicePrint/> },
  { path: "/invoice-reminder", element: <InvoiceReminder/> },
  { path: "/invoice-download/:invoiceId", element: <InvoiceDownload/> },
  { path: "/corn-job", element: <CornJob/> },
  { path: "/send-sms-email-whatsapp", element: <SendSmsEmailWhatsapp/> },
];

export default printRoutes;
